/* @fflow */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PAGINATION_FIRST } from 'constants/constants';

export default class extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        first: PropTypes.any,
        offset: PropTypes.any,
      }),
    }),
    total: PropTypes.number,
  };

  static contextTypes = {
    history: PropTypes.object
  };

  constructor(props: any, context: any): void {
    super(props, context);
  }

  isMin(offset: number): number {
    return offset < 0;
  }

  isMax(offset: number, first: number, total: number): number {
    return Math.ceil(offset / first) >= Math.ceil(total / first);
  }

  render(): React.Element {
    let { history } = this.context;
    let { total, location } = this.props;
    let { pathname, query } = location;
    let { first: f = PAGINATION_FIRST, offset: o = 0 } = query;
    let first = +f;
    let offset = +o;

    let isMin = this.isMin(offset - first);
    let isMax = this.isMax(offset + first, first, total);

    let counterStyle = {
      display: `inline-block`,
      padding: `0 20px`,
      position: `relative`,
      top: `-5px`
    };

    return (
      <div>
        <a onClick={ event => {
          event.stopPropagation();
          if (!isMin) {
            history.pushState(null, pathname, {
              ...query, first, offset: offset - first
            });
          }
        }}
          style={{
            visibility: !isMin ? `visible` : `hidden`,
            cursor: `pointer` }}>
          <i className="material-icons"
            style={{ transform: `rotate(180deg)` }}>play_arrow</i>
        </a>

        <span style={ counterStyle }>
          { (offset / first) + 1 } / { Math.ceil(total / first) }
        </span>

        <a onClick={ event => {
          event.stopPropagation();
          if (!isMax) {
            history.pushState(null, pathname, {
              ...query, first, offset: offset + first
            });
          }
        }}
          style={{
            visibility: !isMax ? `visible` : `hidden`,
            cursor: `pointer` }}>
          <i className="material-icons">play_arrow</i>
        </a>
      </div>
    );
  }
}
